<template>
  <div class="login-main">
    <nav-bar></nav-bar>
    <section class="order-details-start">
      <div class="review-container review-main text-capitalize position-relative">
        <div class="row">
          <div class="text-center col-md-12 p-0 my-2 odr-loadr" v-if="loading">
            <b-spinner class="align-middle"></b-spinner>
          </div>          
          <div class="col-md-12 p-0">
            <div class="resturant-details plr15 order-id">
              <h4 class="text-left">
                {{ $t("Chowman Pay Details") }}
              </h4>
            </div>
            <div class="orders-inner-main plr15 mt-2">
              <div class="orders-lst">
                <div class="order-item order-item-nw d-flex align-items-start pb-4">
                  <div class="smallimg-squre">
                    <img :src="orders.icon_image" @error="$event.target.src = noImge"/>                    
                  </div>                  
                  <div class="order-data ml-3 d-flex align-items-start justify-content-between w-100">
                    <div class="orderid-main">
                      <h6 class="mb-0">{{ orders.restaurant_name }}</h6>
                      <h5 :style="{ color: 'red !important',textTransform:'none' } ">{{orders.unique_code}}</h5>
                    </div>
                  </div>
                </div>
                <div class="inner-data">
                  <!-- <h6 class="mb-1 mt-3">{{ $t("Your Order") }}</h6>-->
                  <div class="billing-data border-0 mt-2">
                    <!-- <h6 class="mb-2">{{ $t("Details") }}</h6> -->
                    <ul>
                      <li class="d-flex justify-content-between">
                        {{ $t("SubTotal") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{parseFloat(orders.total_amount)}}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between promo-discount" v-if="orders.cashback_price > 0">{{ $t("Cashback") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{parseFloat(orders.cashback_price)}}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between promo-discount" v-if="orders.default_cashback > 0">{{ $t("Default Cashback") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{parseFloat(orders.default_cashback)}}</span>
                        </div>
                      </li>
                      <li class="d-flex justify-content-between discount-price" v-if="orders.promocode_discount > 0">{{ $t("Discount") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{parseFloat(orders.promocode_discount)}}</span>
                        </div>
                      </li>                                            
                      <!-- <li class="d-flex justify-content-between walltline" v-if="orders.wallet_price > 0">
                        {{ $t("Wallet") }}
                        <div class="walltline"> - <span v-html="$auth.setting.currency" class="currency"></span><span>{{parseFloat(orders.wallet_price).toFixed(2)}}</span>
                        </div>
                      </li> -->
                      <li class="d-flex justify-content-between bold">
                        {{ $t("Total Paid") }}
                        <div>
                          <span v-html="$auth.setting.currency" class="currency"></span>
                          <span>{{parseFloat(orders.final_amount)}}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <!-- <div class="billing-data border-0 mt-2">
                    <h6 class="mb-2">{{ $t("Pay Details") }}</h6>
                    <ul>
                      <li class="d-flex justify-content-between" v-if="orders.order_id">
                        {{ $t("Order Number") }}
                        <span>#{{ orders.order_id }}</span>
                      </li>
                      <li class="d-flex justify-content-between">
                        {{ $t("Placed Date") }}
                        <span>{{moment(orders.order_date).format("DD/MM/Y hh:mm A")}}</span>
                      </li>
                       <li class="d-flex justify-content-between">
                        {{ $t("Order Type") }}
                        <span>{{ $t(orders.delivery_pickup_types) }}</span>
                      </li>
                      <li class="d-flex justify-content-between">
                        {{ $t("Payment Mode") }}
                        <span>{{ $t(orders.payment_method) }}
                        </span>
                      </li>
                      <li class="d-flex justify-content-between delivery-locality">
                        {{ $t("Delivery Address") }}
                        <span>{{ orders.delivery_address }}</span>
                      </li> 
                    </ul>
                  </div> -->
                </div>
              </div>
            </div>
            <div id="past" v-if="orders.payment_status == 'Cancelled'" class="tab-pane tab-box cncel-ordr">
              <h6>{{ $t("Cancelled Order") }}</h6>              
            </div>
          </div>

          <div class="order-offers" v-if="Object.keys(orders).length == 0 && !loading">
            <p class="text-center">{{ $t("No Order Found") }}</p>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar.vue";
import { mapActions } from "vuex";
import moment from "moment";
import Footer from "../components/Footer.vue";
import noImge from "@/assets/images/place_holder.png";

export default {
  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
      orders: [],
      moment: moment,
      loading: true,
      noImge
    };
  },  
  mounted() {    
    if (this.$auth.user) {
      this.orderDetails();
    } else {
      this.$router.push({ name: "sign-in" });
    }
  },
  methods: {
    ...mapActions("order", ["getchowmanPayOrderDetailsData"]),

    orderDetails() {
      this.loading = true;
      if (this.isBase64(this.$route.params.order_id)) {
        this.getchowmanPayOrderDetailsData({          
          pay_id: this.base64_decode(this.$route.params.order_id),        
        }).then((data) => {          
          if (data.code == 200) {
            this.loading = false;
            this.orders = data.Result;
          }else{
            this.loading = false;
            this.orders = [];
          }
        });
      } else {
        this.loading = false;
        this.orders = [];
      }
    },

    isBase64(str) {
      if (str === "" || str.trim() === "") {
        return false;
      }
      try {
        return btoa(atob(str)) == str;
      } catch (err) {
        return false;
      }
    },
  },
};
</script>
